import { TitleCardsList } from "Components/SelectableCard/Title";
import { Flex, Typography } from "antd";

const options = [
  {
    title: "MBA",
  },
  {
    title: "MS",
  },
];

export const DegreeType = ({ selectedCard, setSelectedCard }) => {
  const { Title } = Typography;
  return (
    <Flex vertical justify="flex-start" align="flex-start">
      <Title style={{ fontSize: "18px", fontWeight: "500", textAlign: "left" }}>
        Degree type
      </Title>
      <TitleCardsList
        options={options}
        selectedCard={selectedCard}
        setSelectedCard={setSelectedCard}
      />
    </Flex>
  );
};
